// Nhãn cho mục "chọn toàn bộ" trong các ô lọc của báo cáo.
//
// Đặt ở một chỗ vì chúng vừa là thứ hiện trên màn hình, vừa là giá trị được so sánh khi người
// dùng chọn — hai bản chép tay lệch nhau một dấu cách là mục đó im lặng ngừng hoạt động.
export const TAT_CA_DON_VI = 'Tất cả đơn vị';
export const TAT_CA_BIEN_SO = 'Tất cả biển số';
export const TAT_CA_LAI_XE = 'Tất cả lái xe';
